import Component from '@glimmer/component';

import safeStyle from 'webapp/helpers/safe-style';
import ToolTipComponent from 'webapp/components/tool-tip';

interface Args {
	percentage?: number;
	target?: number;
	expectedTarget?: string;
	size: 'large' | 'small';
	hideTargetPin?: boolean;
}

export default class CommonProgressBarComponent extends Component<Args> {
	get target() {
		return this.args.target;
	}

	get expectedTarget() {
		return this.args.expectedTarget;
	}

	get percentage() {
		return this.args.percentage;
	}

	get barStyle() {
		const value = Math.min(Math.max(this.percentage || 0, 5), 100);
		return `width: ${value}%;`;
	}

	get goalTarget() {
		if (this.args.hideTargetPin) {
			return null;
		}

		if (this.target !== undefined) {
			const value = Math.min(Math.max(this.target, 3), 97);
			return `${value}%`;
		}
		return null;
	}
	<template>
		<div class="dbx-progress">
			<div class="progress">
				{{#if this.goalTarget}}
					<div
						class="pin pin--{{@size}}"
						style={{safeStyle this.goalTarget property="left"}}
					>
						<ToolTipComponent
							@text="Expected goal value for selected date range: {{this.expectedTarget}}"
							@position="top"
						/>
					</div>
				{{/if}}
				<div class="bar bar--{{@size}}"><em style={{this.barStyle}}></em></div>
			</div>
		</div>
	</template>
}
